<template lang="pug">
	.upload-mraid-io(v-if="showed && Version.SelectedVersion")
		.card
			.card-header
				i.fa.fa-edit
				span {{Metadata.Config['dashboard-domain-title']}} upload
			.card-body.collapse.show(v-if="state === 'idle'")
				.form-horizontal
					.form-group
						label.col-form-label(for="project-folder") Project folder
							.controls
								input.form-control(id="project-folder" size="16" type="text" v-model="projectFolder")
						label.col-form-label(for="version-folder") Version folder
							.controls
								input.form-control(id="version-folder" size="16" type="text" v-model="versionFolder")
						label.col-form-label Release type
							.controls.input-group(v-pseudo-modal-show="'release-type-dropdown'")
								span.form-control.release-type(v-if="!multipleUploadMraidioAllowed || (multipleUploadMraidioAllowed && selectedNetworks.length === 1)") {{releaseType}}
								span.form-control.release-type(v-else) {{selectedNetworks.length + ' releases'}}
								.input-group-append
									span.input-group-text
										i.fa.fa-angle-down
							.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'release-type-dropdown'" :class="{'multiple-upload': Project.SelectedProject.type === 'playable' && multipleUploadMraidioAllowed}")
								.dropdown-header(class="text-center")
									strong Choose release type
									span.multiple-upload-switch(v-if="isShowMultipleUploadMraidio()" v-b-tooltip.hover="{title: 'Enable multiple upload'}" @click.stop.prevent="switchMultipleUploadMraidio")
										.switch-control
											label.float-right.switch.switch-label.switch-sm.switch-pill.switch-success.form-check-label
												input.switch-input.form-check-input(type="checkbox" :checked="multipleUploadMraidioAllowed")
												span.switch-slider(data-checked="On" data-unchecked="Off")
												span.switch-handle
								NetworkList(:callback="chooseReleaseType" scope="upload" :multipleAllowed="multipleUploadMraidioAllowed" network="mraid")

					.form-result
						span https://{{domain}}/releases/{{projectFolder}}/{{versionFolder}}/
					.form-actions
						button.btn.btn-primary.upload(type="submit" v-on:click="upload()" :disabled="multipleUploadMraidioAllowed && selectedNetworks < 1")
							i.fa.fa-upload
							| &nbsp;&nbsp;Upload
						button.btn.btn-dark.close-button(type="button" v-on:click="hide()") Cancel
			.card-body.collapse.show(v-if="state === 'preparing' || state === 'release' || state === 'uploading' || state === 'error'")
				.processing
					.icon.fa.fa-spinner.fa-spin
					.text(v-if="state === 'preparing'") preparing...
					.text(v-if="state === 'release'") creating release...
					.text(v-if="state === 'uploading'") uploading...
					.text.danger(v-if="state === 'error'") Error
			.card-body.collapse.show(v-if="state === 'result'")
				.result
					.text(v-if="result && result.type === 'tag'")
						textarea {{result.data}}
					.text(v-if="result && result.type === 'file-link'")
						a(v-bind:href="result.data" target="_blank") {{result.data}}
				.form-horizontal
					.form-actions
						button.btn.btn-primary.copy(type="submit" v-on:click="copy()")
							i.fa.fa-copy
							| &nbsp;&nbsp;Copy
						button.btn.btn-dark.close-button(type="button" v-on:click="close()") Close
</template>

<script>

	import changeCase 			from "change-case"

	import Screen 				from './../../mixins/screen'

	import { Publisher } 		from './../../services/Publisher'
	import { Project } 			from './../../services/Project'
	import { Version } 			from './../../services/Version'
	import { Settings } 		from './../../services/Settings'
	import { Layout } 			from './../../services/Layout'
	import { User } 			from "./../../services/User"
	import { Server } 			from "./../../services/Server"

	import NetworkList 			from './../Templates/NetworksList'

	import SetupSettings 		from '../../settings/settings.json'

	export default {
		name: "UploadMraidio",
		mixins: [Screen],
		screen: {
			updateOn: ["Multiple Upload Mraidio Networks Changed"],
			events: {

				"Mraidio Upload Progress": function(data) {

					if (data.MraidioUploadProjectId === Project.SelectedProject.id && data.MraidioUploadVersionId === Version.SelectedVersion.id) {

						this.state = data.MraidioUploadProgress;

						if (data.MraidioUploadResult) {

							this.result = data.MraidioUploadResult;

						}

						this.update();

						this.$nextTick(() => {

							if (data.MraidioUploadResult) {

								Broadcast.call("Mraidio Upload Progress Finished");

							} else {

								Broadcast.call("Mraidio Upload Progress Changed");

							}

						});

					}

				},

				"Multiple Upload Mraidio Networks Changed": function(count) {

					this.selectedNetworks = this.getSelectedReleasesForUpload();

					this.updateVersionFolder();

				}

			}
		},
		components: {
			NetworkList
		},
		data() {

			this.Publisher = Publisher;
			this.Project = Project;
			this.Version = Version;
			this.Settings = Settings;

			return {
				domain: SetupSettings['domain'],
				state: 'idle', //'preparing', 'release', 'uploading', 'result'
				projectFolder: '',
				versionFolder: '',
				releaseType: 'mraid',
				result: {},
				multipleUploadMraidioAllowed: false,
				selectedNetworks: 0
			};

		},
		computed: {
		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion) return;

				this.projectFolder = Project.SelectedProject ? Project.SelectedProject.codename : '';

				if (Publisher.SelectedPublisher && this.projectFolder.indexOf(Publisher.SelectedPublisher.codename) === 0) this.projectFolder = this.projectFolder.substr(Publisher.SelectedPublisher.codename.length + 1);

				this.multipleUploadMraidioAllowed = User.currentUser?.options?.features?.multipleUploadMraidio && this.isShowMultipleUploadMraidio();

				this.selectedNetworks = this.getSelectedReleasesForUpload();

				this.updateVersionFolder();

			},

			getSelectedReleasesForUpload() {

				let releases = Object.keys(User.currentUser?.options?.features?.multipleUploadMraidioNetworks || {}).filter(release => Settings.isReleaseAvailable(release, this.multipleUploadMraidioAllowed, 'upload'));

				if (releases.length === 1 && this.multipleUploadMraidioAllowed) this.releaseType = releases[0];

				return releases;

			},

			updateVersionFolder() {

				if (!this.multipleUploadMraidioAllowed) this.versionFolder = changeCase.paramCase(Version.SelectedVersion.codename || Version.SelectedVersion.title) + '-' + this.releaseType;
				else {
					if (!this.selectedNetworks.length) this.versionFolder = '';
					else if (this.selectedNetworks.length === 1) this.versionFolder = changeCase.paramCase(Version.SelectedVersion.codename || Version.SelectedVersion.title) + '-' + this.selectedNetworks[0];
					else this.versionFolder = changeCase.paramCase(Version.SelectedVersion.codename || Version.SelectedVersion.title) + '-{network-name}';
				}

			},

			upload() {

				let releasesTypes = [];
				if (this.multipleUploadMraidioAllowed && this.selectedNetworks.length) releasesTypes = this.selectedNetworks;
				else releasesTypes = [this.releaseType];

				Broadcast.call("Mraidio Upload Progress Starting");

				Server.sendToSocket({
					MraidioUpload: {
						projectId: Project.SelectedProject.id,
						versionId: Version.SelectedVersion.id,
						releasesTypes: releasesTypes,
						projectFolder: this.projectFolder,
						versionFolder: changeCase.paramCase(this.versionFolder.replace('{network-name}', ''))
					}
				});

				this.state = 'processing';

			},

			switchMultipleUploadMraidio() {

				if (event.target.classList.contains('switch-input')) return;
				this.multipleUploadMraidioAllowed = !this.multipleUploadMraidioAllowed;
				User.toggleFeature(User.currentUser.id, 'multipleUploadMraidio', this.multipleUploadMraidioAllowed);

				this.updateVersionFolder();

			},
			chooseReleaseType(type) {

				this.releaseType = type;

				this.collectData();

				Broadcast.call("Pseudo Modal Hide", ['release-type-dropdown']);

			},
			copy() {

				let text = '';

				if (this.result) text = this.result.data;

				Layout.copyTextToClipboard(text);

				Broadcast.call("Tag Code Copied"); // Нужно для системы обучения

			},
			close() {

				this.state = 'idle';

				this.hide();

			},

			isShowMultipleUploadMraidio() {

				let show = true;

				if (Project.SelectedProject.type !== 'playable') show = false;

				if (Publisher.SelectedPublisher && Publisher.SelectedPublisher.options) {

					let releaseNames = Publisher.SelectedPublisher.options.ReleaseNames;

					if (releaseNames === 'version-names-only' || releaseNames === 'use-title') show = false;

				}

				return show;

			}
		}
	}
</script>


<style lang="sass">

	.upload-mraid-io
		position: absolute
		z-index: 1020
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 500px
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 400px
			box-shadow: 0 0 20px rgba(0, 0, 0, 0.8)

			input
				width: 460px
				margin-top: 5px

			.btn-ghost-dark, .btn-dark
				float: right
				color: #fff

			.form-actions
				position: absolute
				right: 19px
				bottom: 20px
				width: calc(100% - 40px)

				.btn.btn-primary:disabled
					cursor: not-allowed

			.form-control.release-type
				cursor: pointer
				width: 150px
				margin-top: 5px
				user-select: none

			.input-group-append
				margin-top: 5px
				cursor: pointer

				.input-group-text
					background-color: #343b41
					border: 1px solid #23282c
					color: #e4e7ea

		.two-setting-panel
			display: flex
			flex-direction: row
			justify-content: space-between

			.setting-one

				.form-control.region
					width: 200px

		.form-result
			color: #20a8d8
			font-size: 11px

		.dropdown-menu
			position: absolute
			right: 44px
			top: auto
			bottom: 114px
			display: block
			z-index: 10000
			line-height: 1.5
			width: 250px
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)

			.dropdown-header
				cursor: default
				display: flex
				flex-direction: row
				justify-content: space-between

				>.multiple-upload-switch
					opacity: 0.3

			.networks
				height: 350px
				overflow-x: hidden
				overflow-y: auto

				.dropdown-item
					white-space: normal
					padding: 0px 20px 10px 20px
					width: 250px

			.networks::-webkit-scrollbar
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			.networks::-webkit-scrollbar-track
				background-color: rgba(255,255,255,0.3)
				border-right: 1px solid #f2f2f2
				border-left: 1px solid #f2f2f2

			.networks::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(255,255,255,0.2)
				background-clip: content-box
				border-color: transparent
				border-style: solid
				border-width: 1px 2px

			&.multiple-upload
				right: 14px
				width: 280px

				>.dropdown-header
					padding: 8px 50px 8px 20px

					>.multiple-upload-switch
						opacity: 1

				.dropdown-item
					width: 280px
					padding-left: 50px

		.processing
			height: 100%
			display: flex
			flex-direction: column
			align-items: center
			justify-content: center

			.icon
				display: inline
				font-size: 30px

		.result

			textarea
				width: 100%
				height: 250px
				background: transparent
				border: none
				color: #fff
				font-size: 12px
				white-space: pre
				overflow-wrap: normal
				overflow-x: auto
</style>

